import { render, staticRenderFns } from "./HistoricoEmail.vue?vue&type=template&id=52657001&scoped=true"
import script from "./HistoricoEmail.vue?vue&type=script&lang=js"
export * from "./HistoricoEmail.vue?vue&type=script&lang=js"
import style0 from "./HistoricoEmail.vue?vue&type=style&index=0&id=52657001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52657001",
  null
  
)

export default component.exports